<template>
	<v-layout row wrap>
		<v-flex sm12 md6>
			<v-layout row wrap>
				<v-flex xs12 class="pa-1">
					<p class="add-event-step-header">Pictures</p>
					<p class="add-event-step-sub-header mb-3">Try to add <strong>at least 3 photos</strong> that communicate the look and feel of this space. And IF POSSIBLE, pictures that show people working or mingling in the space.  Don't have perfect pics?  No worries!  Just upload enough to communicate the look and feel - we'll take care of the rest.</p>
					<p class="text-xs-center" style="font-size: 1em; color: #888;">Drop or click below to upload images</p>
					<vue-dropzone
						ref="imageDropzone"
						id="dropzone"
						:options="dropzoneOptions"
						v-on:vdropzone-removed-file="removeFile"
						v-on:vdropzone-success="uploadSuccess"
						v-on:vdropzone-queue-complete="uploadComplete"
						v-on:vdropzone-sending="uploadStarted"
					></vue-dropzone>
					<v-select
						color="link"
						avatar
						v-model="primaryImage"
						label="Primary Image"
						hide-details
						item-text="name"
						item-value="pk"
						item-avatar="image"
						:items="images"
						class="mt-4"
						style="z-index:22!important; margin-bottom: 150px;"
						:menu-props="{maxHeight:'300'}"
					>
						<template slot="selection" slot-scope="data">
							<div class="pa-1">
								<v-avatar class="mr-3" size="32">
									<img :src="data.item.image">
								</v-avatar>
								{{ data.item.name }}
							</div>
						</template>
						<template slot="item" slot-scope="data">
							<template v-if="typeof data.item !== 'object'">
								<v-list-tile-content v-text="data.name"></v-list-tile-content>
							</template>
							<template v-else>
								<v-list-tile-avatar>
									<img v-bind:src="data.item.image"/>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title v-html="data.item.name"></v-list-tile-title>
								</v-list-tile-content>
							</template>
						</template>
					</v-select>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="text-xs-center add-event-tip-title">Hint:</p>
					<p class="add-event-tip-content">Don't have pictures of people together at your space?  No stress!</p>
					<p class="add-event-tip-content">For now, just add pictures that show the space and we'll help you with getting better pics for the promotions.</p>
					<p class="add-event-tip-content">Remember: pictures tell a powerful store.  Having more photos gives your guests a better idea of what to expect.</p>
					<p class="add-event-tip-content">And make some of your pictures show where guests will sit and work. Pictures of a common area where guests can chat are also a big help.</p>
					<p class="add-event-tip-content">And maybe the little things, too!  The view from inside looking out...  The growing collection of interesting books you keep around...  Get creative!</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-content">Don't have pictures of people together at your space?  No stress!</p>
					<p class="add-event-tip-content">For now, just add pictures that show the space and we'll help you with getting better pics for the promotions.</p>
					<p class="add-event-tip-content">Remember: pictures tell a powerful store.  Having more photos gives your guests a better idea of what to expect.</p>
					<p class="add-event-tip-content">And make some of your pictures show where guests will sit and work. Pictures of a common area where guests can chat are also a big help.</p>
					<p class="add-event-tip-content">And maybe the little things, too!  The view from inside looking out...  The growing collection of interesting books you keep around...  Get creative!</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import * as Cookies from 'js-cookie'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'
import { deepCloneArray } from '~/utils/helper'
import { mapGetters, mapActions } from 'vuex'

import * as TYPES from '~/store/util/types'
export default {
	data() {
		return {
			photosUploading: false,
			validSeats: false,
			removingImage: false,
			images: [],
			leaving: false, // To stop the removeFile method firing on page leave
			dropzoneOptions: {
				paramName: 'image',
				url: process.env.VUE_APP_SERVER_PROTOCOL + process.env.VUE_APP_SERVER_URL + 'api/v1/image-upload/',
				thumbnailWidth: 150,
				resizeMimeType: 'image/jpeg',
				resizeWidth: 1600,
				uploadMultiple: false,
				acceptedFiles: 'image/*',
				maxFilesize: 10,
				maxFiles: 25,
				duplicateCheck: true,
				addRemoveLinks: true,
				ignoreHiddenFiles: true,
				dictDefaultMessage: '<i style="font-size: 2.5em" class="fa fa-cloud-upload"></i>',
				headers: { Authorization: 'Bearer ' + this.$store.getters.getToken }
			}
		}
	},
	created() {
		this.images = deepCloneArray(this.getAddLocationProp('imageObjs'))
	},
	mounted() {
		let imageObjs = deepCloneArray(this.getAddLocationProp('imageObjs'))
		let mockImage
		for (let i = 0; i < imageObjs.length; i++) {
			mockImage = {
				name: imageObjs[i].name,
				size: imageObjs[i].filesize,
				type: "image/*",
				pk: imageObjs[i].pk
			}
			this.$refs.imageDropzone.manuallyAddFile(mockImage, imageObjs[i].image)
		}
	},
	// beforeRouteEnter (to, from, next) {
	// 	this.leaving = false
	// 	next()
	// },
	beforeRouteLeave(to, from, next) {
		this.leaving = true
		if (this.getAddLocationProp('images').length >= 1) {
			this.setAddLocationValidStep(from.path)
			this.removeAddLocationInvalidStep(from.path)
		} else {
			this.removeAddLocationValidStep(from.path)
			this.setAddLocationInvalidStep(from.path)
		}
		if (this.photosUploading) {
			this.setSnackbarText('Wait for photos to finish uploading')
			this.setSnackbarOpen(true)
			next(false)
		} else {
			next()
		}
	},
	methods: {
		...mapActions([
			'setAddLocationProp',
			'addLocationProcessFiles',
			'setAddLocationValidStep',
			'removeAddLocationValidStep',
			'setAddLocationInvalidStep',
			'removeAddLocationInvalidStep',
			'serverRemoveImage',
			'setSnackbarOpen',
			'setSnackbarText'
		]),
		removeFile(image, message, xhr) {
			// Dev note :: This function is called both when the user removes/deletes an image, and when they leave the page
			console.log(image)
			let objIndex
			let data
			if (image.status === 'canceled') {
				return
			}
			if (image.hasOwnProperty('xhr')) {
				// If image was uploaded during the current page visit
				data = JSON.parse(image.xhr.response)
				let i = this.images.find(obj => {
					return obj.pk === data.pk
				})
				objIndex = this.images.indexOf(i)
			} else {
				// If the image was added from the browser localstorage (user left photos page and came back)
				data = image
				let i = this.images.find(obj => {
					return obj.pk === image.pk
				})
				objIndex = this.images.indexOf(i)
			}
			if (!this.leaving) {
				// If function was called from user deleting the image (not leaving the page)
				this.serverRemoveImage(data.pk)
				if (this.images.length > 1) {
					if (
						this.getAddLocationProp('primaryImage') === this.images[objIndex].pk
					) {
						this.images.splice(objIndex, 1)
						this.setAddLocationProp({
							prop: 'primaryImage',
							value: this.images[0].pk
						})
					} else {
						this.images.splice(objIndex, 1)
						this.setAddLocationProp({ prop: 'primaryImage', value: null })
					}
				} else {
					this.images = []
					this.setAddLocationProp({ prop: 'primaryImage', value: null })
				}
				this.setAddLocationProp({
					prop: 'images',
					value: deepCloneArray(this.images.map(obj => obj.pk))
				})
				this.setAddLocationProp({
					prop: 'imageObjs',
					value: deepCloneArray(this.images)
				})
			}
		},
		removeFile2(image, message, xhr) {
			if (image.status === 'canceled') {
				return
			}
			if (image.hasOwnProperty('xhr')) {
				let data = JSON.parse(image.xhr.response)
				let i = this.images.find(obj => {
					let data = JSON.parse(image.xhr.response)
					return obj.pk === data.pk
				})
				let objIndex = this.images.indexOf(i)
				if (!this.leaving) {
					this.serverRemoveImage(data.pk)
					if (this.images.length > 1) {
						if (
							this.getAddLocationProp('primaryImage') ===
							this.images[objIndex].pk
						) {
							this.images.splice(objIndex, 1)
							this.setAddLocationProp({
								prop: 'primaryImage',
								value: this.images[0].pk
							})
						} else {
							this.images.splice(objIndex, 1)
						}
					} else {
						this.images = []
						this.setAddLocationProp({ prop: 'primaryImage', value: null })
					}
				}
			} else {
				let i = this.images.find(obj => {
					return obj.pk === image.pk
				})
				let objIndex = this.images.indexOf(i)
				if (!this.leaving) {
					this.serverRemoveImage(image.pk)
					if (this.images.length > 1) {
						if (
							this.getAddLocationProp('primaryImage') ===
							this.images[objIndex].pk
						) {
							this.images.splice(objIndex, 1)
							this.setAddLocationProp({
								prop: 'primaryImage',
								value: this.images[0].pk
							})
						} else {
							this.images.splice(objIndex, 1)
							this.setAddLocationProp({ prop: 'primaryImage', value: null })
						}
					} else {
						this.images = []
						this.setAddLocationProp({ prop: 'primaryImage', value: null })
					}
				}
			}
			if (!this.leaving) {
				this.setAddLocationProp({
					prop: 'images',
					value: deepCloneArray(this.images.map(obj => obj.pk))
				})
				this.setAddLocationProp({
					prop: 'imageObjs',
					value: deepCloneArray(this.images)
				})
			}
		},
		uploadSuccess(image, response) {
			if (
				this.getAddLocationProp('primaryImage') === null ||
				this.getAddLocationProp('images').length === 0
			) {
				this.setAddLocationProp({ prop: 'primaryImage', value: response.pk })
			}

			this.images.push({
				name: response.filename,
				pk: response.pk,
				image: response.image,
				filesize: image.size
			})
			this.setAddLocationProp({
				prop: 'images',
				value: deepCloneArray(this.images.map(obj => obj.pk))
			})
			this.setAddLocationProp({
				prop: 'imageObjs',
				value: deepCloneArray(this.images)
			})
		},
		uploadComplete(file, xhr, formData) {
			this.photosUploading = false
		},
		uploadStarted(file, xhr, formData) {
			this.photosUploading = true
		}
	},
	computed: {
		...mapGetters(['getAddLocationProp', 'getToken']),
		primaryImage: {
			get() {
				return this.getAddLocationProp('primaryImage')
			},
			set(val) {
				this.setAddLocationProp({ prop: 'primaryImage', value: val })
			}
		},
		infoDialog: {
			get() {
				return this.getAddLocationProp('infoDialog')
			},
			set(val) {
				this.setAddLocationProp({ prop: 'infoDialog', value: val })
			}
		}
	},
	components: {
		vueDropzone: vue2Dropzone
	}
}
</script>

<style lang="scss">
</style>
